import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi, NodePOSTApi, sendOTPEmail } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import FileUpload from "../../../FileUpload";
import ImageUpload from "../../../ImageUpload";
import { CustomButtonUnSelect } from "../../../CustomButtomUnselect";
import StaffViewCard from "./PersonalDetails";
import { CSVLink } from "react-csv";
import topicSuggestion from '../../../../Constant/topics.json'
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";
const { adToBs, bsToAd, calculateAge } = require('@sbmdkl/nepali-date-converter');


export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [Code, setCode] = React.useState(FetchData.meta.code)
  const [Name, setName] = React.useState(FetchData.meta.name)
  const [Email, setEmail] = React.useState(FetchData.meta.email)
  const [Phone1, setPhone1] = React.useState(FetchData.meta.phone)
  const [Phone2, setPhone2] = React.useState(FetchData.meta.phone2)
  const [Photo, setPhoto] = React.useState(FetchData.meta.photo)
  const [Address, setAddress] = React.useState(FetchData.meta.address)
  const [Type, setType] = React.useState(FetchData.meta.type)
  const [IsActive, setIsActive] = React.useState(FetchData.meta.is_active)
  const [JoiningDate, setJoiningDate] = React.useState(FetchData.meta.joining_date)
  const [BankAccountNumber, setBankAccountNumber] = React.useState(FetchData.meta.bank_account_number)
  const [PanNumber, setPanNumber] = React.useState(FetchData.meta.pan_number)
  const [Attendance, setAttendance] = React.useState(FetchData.meta.attendance == "" ? [] : JSON.parse(FetchData.meta.attendance))
  const [Salary, setSalary] = React.useState(FetchData.meta.salary)
  const [Class, setClass] = React.useState(FetchData.meta.class == "" ? [] : JSON.parse(FetchData.meta.class))
  const [Payrolls, setPayrolls] = React.useState(FetchData.meta.payrolls == "" ? [] : JSON.parse(FetchData.meta.payrolls))
  const [ZoomID, setZoomID] = React.useState(FetchData.meta.zoom_id)
  const [openTopicPopup, setOpenTopicPopup] = React.useState(null);
  const [opencalendar, setOpencalendar] = React.useState(false);

  // const [editPersonalInfo, setEditPersonalInfo] = React.useState(false)
  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")

  const [ShowCourseGroupList, setShowCourseGroupList] = React.useState(true)

  const [CourseSelectModal, setCourseSelectModal] = React.useState(false)
  const [CourseSelectIndex, setCourseSelectIndex] = React.useState(false)
  const [CourseSelectItem, setCourseSelectItem] = React.useState(false)

  const [CourseList, setCourseList] = React.useState([])
  const [CourseDetails, setCourseDetails] = React.useState(FetchData.meta.class == "" ? [] : JSON.parse(FetchData.meta.class))
  // const [CourseDetails, setCourseDetails] = React.useState([])
  const [CourseSelectModalAtt, setCourseSelectModalAtt] = React.useState(false)
  const [CourseSelectIndexAtt, setCourseSelectIndexAtt] = React.useState(false)
  const [CourseSelectItemAtt, setCourseSelectItemAtt] = React.useState(false)

  const [PaymentHistory, setPaymentHistory] = React.useState(FetchData.meta.payrolls == "" ? [] : JSON.parse(FetchData.meta.payrolls))
  const [PaymentList, setPaymentList] = React.useState([])
  const AttendanceRef = React.useRef(null)
  const [TopicList1, setTopicList1] = React.useState([])
  const [TopicList2, setTopicList2] = React.useState([])
  const [EmailModal, setEmailModal] = React.useState(false)


  const EditInfo = () => {
    setReload(true)
    const data = {
      "title": `${Name}`,
      "status": "publish",
      "meta": {
        "code": `${Code}`,
        "name": `${Name}`,
        "email": `${Email}`,
        "phone": `${Phone1}`,
        "phone2": `${Phone2}`,
        "photo": `${Photo}`,
        "address": `${Address}`,
        "type": `${Type}`,
        "is_active": `${IsActive}`,
        "joining_date": `${JoiningDate}`,
        "bank_account_number": `${BankAccountNumber}`,
        "pan_number": `${PanNumber}`,
        "attendance": JSON.stringify(Attendance),
        "salary": `${Salary}`,
        "class": JSON.stringify(CourseDetails),
        "payrolls": JSON.stringify(Payrolls),
        "zoom_id":`${ZoomID}`
      }
    }

    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_employee)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Employedd Added Successfully")
          history.push(`${slugs.employee_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_employee, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`Successfully Edited`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }

  useEffect(() => {
    getBatches()
    getTopic()
    if (ID !== "")
      getPaymentHistory()
    sortForDownload(Attendance)
  }, [])

  const getBatches = () => {
    AdsGETApiAuth({
      _fields: "id,meta,title"
    }, slugs.db_slug_batches)
      .then((res) => {
        setCourseList(res.data)
      })
  }

  const getTopic = () => {
    AdsGETApiAuth({
      per_page: 1,
      _fields: "id,meta,title"
    }, slugs.db_slug_topics)
      .then((res) => {
        var getTopics = Object.values(JSON.parse(res.data[0].meta.topics_details))
        setTopicList1(getTopics)
        setTopicList2(getTopics)
        console.log(getTopics)
      })
  }

  const getPaymentHistory = () => {
    AdsGETApiAuth({
      _fields: "id,meta,title,slug,date",
      "filter[meta_query][1][key]": "employee_id",
      "filter[meta_query][1][value][0]": `${ID}`,
      "filter[meta_query][1][compare]": "=",
    }, slugs.db_slug_expenses)
      .then((res) => {
        setPaymentList(res.data)
      })
  }

  const [CustomersDownload, setCustomersDownload] = React.useState([])
  const date = new Date()
  const sortForDownload = (Att) => {
    var DataArray = Object.values(Att)
    var dData = []
    for (let i = 0; i < DataArray.length; i++) {
      var item = DataArray[i]
      dData.push({
        "Course Name": DataArray[i].course_name,
        "Batch Name": DataArray[i].batch_name,
        "Session": DataArray[i].session,
        "Date": DataArray[i].date,
        "Start Time": DataArray[i].time_start,
        "End Time": DataArray[i].time_end,
        "Amount": DataArray[i].price,
        "TDS": Number(DataArray[i].price) * 0.15,
        "AfterTDS": Number(DataArray[i].price) * 0.85,
        "Topic": DataArray[i].topic,
        "Status": DataArray[i].payment_status
      })
    }
    setCustomersDownload(dData)
    console.log("done", dData)
  }


  const headers = [
    { label: "Course Name", key: "Course Name" },
    { label: "Batch Name", key: "Batch Name" },
    { label: "Session", key: "Session" },
    { label: "Start Time", key: "Start Time" },
    { label: "End Time", key: "End Time" },
    { label: "Amount", key: "Amount" },
    { label: "TDS", key: "TDS" },
    { label: "Total", key: "AfterTDS" },
    { label: "Topic", key: "Topic" },
    { label: "Status", key: "Status" },
  ];


  return (
    <div>
      <div className="row">
        <div className="col-1"></div>
        <div className="col-10 form-view mb-3">
          <h4><center>Staff Information</center></h4>

          <table>
            <tbody>
              <tr>
                <td className="col-3">Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Name} placeholder="Name"
                    onChange={(event) => { setName(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Phone1</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Phone1} placeholder="Phone 1"
                    onChange={(event) => { setPhone1(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Email</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Email} placeholder="Email"
                    onChange={(event) => { setEmail(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Phone 2</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Phone2} placeholder="Phone 2"
                    onChange={(event) => { setPhone2(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Photo</td>
                <td className="col-6">
                  <ImageUpload ImageUrl={Photo}
                    setImageUrl={setPhoto} />
                </td>
              </tr>
              {/* <tr>
                <td className="col-3">Address</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Address} placeholder="Address"
                    onChange={(event) => { setAddress(event.target.value) }}
                  />
                </td>
              </tr> */}
              <tr>
                <td className="col-3">IsActive</td>
                <td className="col-6">
                  <CustomButton setData={setIsActive} Data={IsActive} DataValue={"Active"} />
                  <CustomButton setData={setIsActive} Data={IsActive} DataValue={"Inactive"} />
                </td>
              </tr>
              <tr>
                <td className="col-3">Zoom ID</td>
                <td className="col-6">
                  <input className="input-common"
                    value={ZoomID} placeholder="Zoom"
                    onChange={(event) => { setZoomID(event.target.value) }}
                  />
                </td>
              </tr>
              {/* <tr>
                <td className="col-3">Staff/Teacher</td>
                <td className="col-6">
                  <CustomButton setData={setType} Data={Type} DataValue={"Teacher"} />
                  <CustomButton setData={setType} Data={Type} DataValue={"Staff"} />
                </td>
              </tr> */}
              {/* <tr>
                <td className="col-3">Joining Date</td>
                <td className="col-6">
                  <input className="input-common"
                    value={JoiningDate} placeholder="Joining Date"
                    onChange={(event) => { setJoiningDate(event.target.value) }}
                  />
                </td>
              </tr> */}
              {/* <tr>
                <td className="col-3">Bank Account Number</td>
                <td className="col-6">
                  <input className="input-common"
                    value={BankAccountNumber} placeholder="Bank Account Number"
                    onChange={(event) => { setBankAccountNumber(event.target.value) }}
                  />
                </td>
              </tr> */}
              {/* <tr>
                <td className="col-3">Pan Number</td>
                <td className="col-6">
                  <input className="input-common"
                    value={PanNumber} placeholder="PAN Number"
                    onChange={(event) => { setPanNumber(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Salary</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Salary} placeholder="Salary"
                    onChange={(event) => { setSalary(event.target.value) }}
                  />
                </td>
              </tr> */}
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update {Type}
              </div>
            </div>
          </div>
        </div>
      </div >

      {Type == "Teacher" &&

        <div className="row" style={{ display: "none" }}>
          <div className="col-sm-2 col-1"></div>
          <div className="col-sm-8 col-10 form-view mb-3">
            <h4><center>Courses</center></h4>
            <table>
              <tr>
                <td>SN</td>
                <td>Course</td>
                <td>Batch</td>
                <td>Session</td>
                {/* <td>Price</td> */}
                {/* <td>Joined Price</td> */}
                <td>Class Start</td>
              </tr>
              <tbody>
                {Object.values(CourseDetails).map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td
                      onClick={() => {
                        setCourseSelectModal(true)
                        setCourseSelectItem(item)
                        setCourseSelectIndex(index)
                      }}
                    >
                      <div className="input-common">{item.course_name}&nbsp;</div>
                    </td>
                    <td
                      onClick={() => {
                        setCourseSelectModal(true)
                        setCourseSelectItem(item)
                        setCourseSelectIndex(index)
                      }}
                    >
                      <div className="input-common">{item.batch_name}&nbsp;</div>
                    </td>
                    <td
                      onClick={() => {
                        setCourseSelectModal(true)
                        setCourseSelectItem(item)
                        setCourseSelectIndex(index)
                      }}
                    >
                      <div className="input-common">{item.session}&nbsp;</div>
                    </td>
                    {/* <td>
                          <input className="input-common-items" disabled value={item.price} />
                        </td> */}
                    {/* <td>
                          <input className="input-common-items" type="number"
                            value={item.course_joined_price} placeholder="Joining Price"
                            onChange={(event) => {
                              setCourseDetails({
                                ...CourseDetails,
                                [Object.keys(CourseDetails)[index]]: {
                                  ...Object.values(CourseDetails)[index],
                                  "course_joined_price": event.target.value
                                }
                              })
                            }}
                          />
                        </td> */}
                    <td>
                      <input className="input-common" type="date"
                        value={item.course_joined_date} placeholder="Items"
                        onChange={(event) => {
                          setCourseDetails({
                            ...CourseDetails,
                            [Object.keys(CourseDetails)[index]]: {
                              ...Object.values(CourseDetails)[index],
                              "course_joined_date": event.target.value
                            }
                          })
                        }}
                      />
                    </td>
                    <td>
                      {/* <span style={{ cursor: "pointer", padding: "10px 5px" }} onClick={() => {
                        var ObjectForDelete = CourseDetails
                        var key = Object.keys(CourseDetails)[index]
                        // console.log(key, Items)
                        delete ObjectForDelete[key];
                        setCourseDetails(ObjectForDelete)
                        setShowCourseGroupList(false)
                        setTimeout(() => {
                          setShowCourseGroupList(true)
                        }, 10)
                      }}>
                        Delete
                      </span> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="row center m-2">
              <div className=" col-3" style={{ padding: "0 10px" }}>
                <div className="sign-in-button-1"
                  onClick={() => {
                    var newValue = {
                      course_name: "",
                      batch_name: "",
                      session: "",
                      price: "",
                      course_joined_price: "",
                      course_joined_date: ""
                    }
                    var lastkey = Object.keys(CourseDetails).length == 0 ? -1 : Number(Object.keys(CourseDetails)[Object.keys(CourseDetails).length - 1])
                    var newKey = `${lastkey + 1}`
                    var newObject = CourseDetails;
                    newObject = {
                      ...CourseDetails,
                      [newKey]: newValue
                    }
                    // console.log(newObject)

                    setCourseDetails(newObject)
                  }}
                >
                  Add Course
                </div>
              </div>
            </div>
          </div>
        </div>
      }


      {Type == "Teacher" &&
        <div>
          <div className="row">
            <div className="col-1"></div>
            <div className="col-10 form-view mb-3">
              <h4><center>Attendance</center></h4>
              <div
                ref={AttendanceRef}
                style={{ maxHeight: "300px", overflowY: "scroll", scrollBehavior: "smooth" }}>
                <div className="table-scroll">
                  <table className="long-table">
                    <tr>
                      <td>SN</td>
                      <td>Course</td>
                      <td>Batch</td>
                      <td>Session</td>
                      <td>Date</td>
                      <td>Time Start</td>
                      <td>Time End</td>
                      <td>Topic</td>
                      {/* <td>Price</td>
                      <td>TDS</td>
                      <td>After TDS</td> */}
                      {/* <td>Status</td> */}
                    </tr>
                    <tbody>
                      {Object.values(Attendance).map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          {Type == "Teacher" &&
                            <>
                              <td style={{ width: "200px" }}
                                onClick={() => {
                                  if (item.payment_status !== "Settled") {
                                    setCourseSelectModalAtt(true)
                                    setCourseSelectItem(item)
                                    setCourseSelectIndexAtt(index)
                                  }
                                }}
                              >
                                <div className="input-common">{item.course_name}&nbsp;</div>
                              </td>
                              <td
                                onClick={() => {
                                  if (item.payment_status !== "Settled") {
                                    setCourseSelectModalAtt(true)
                                    setCourseSelectItem(item)
                                    setCourseSelectIndexAtt(index)
                                  }
                                }}
                              >
                                <div className="input-common">{item.batch_name}&nbsp;</div>
                              </td>
                              <td
                                onClick={() => {
                                  if (item.payment_status !== "Settled") {
                                    setCourseSelectModalAtt(true)
                                    setCourseSelectItem(item)
                                    setCourseSelectIndexAtt(index)
                                  }
                                }}
                              >
                                <div className="input-common">{item.session}&nbsp;</div>
                              </td>
                            </>
                          }
                          <td className="nepali-date-cell">
                            {/* <div className="topic-popup"> */}
                            <div className="attendance-date-picker">
                              <div className="small-nepali-datepicker"
                                onClick={() => { setOpencalendar(true) }}
                              >
                                <NepaliDatePicker style={{ cursor: "pointer" }}
                                  inputClassName="input-common"
                                  value={item.date || ""}
                                  onChange={(selectedDate) => {
                                    var newAttendence = {
                                      ...Attendance,
                                      [Object.keys(Attendance)[index]]: {
                                        ...Object.values(Attendance)[index],
                                        "date": selectedDate
                                      }
                                    }
                                    setAttendance(newAttendence)
                                    sortForDownload(newAttendence)
                                    setOpencalendar(false)
                                  }
                                  }
                                  options={{
                                    calenderLocale: "ne",
                                    valueLocale: "en",
                                  }}
                                  placeholder="मिति छान्नुहोस्"
                                // onSelect={() => { setOpencalendar(true) }}
                                />
                              </div>
                            </div>
                          </td>
                          <td>
                            <input className="input-common" style={{ width: "80px" }}
                              value={item.time_start} placeholder="Time Start" disabled={item.payment_status == "Settled"}
                              onChange={(event) => {
                                var newAttendence = {
                                  ...Attendance,
                                  [Object.keys(Attendance)[index]]: {
                                    ...Object.values(Attendance)[index],
                                    "time_start": event.target.value
                                  }
                                }
                                setAttendance(newAttendence)
                                sortForDownload(newAttendence)
                              }}
                            />
                          </td>
                          <td>
                            <input className="input-common" style={{ width: "80px" }}
                              value={item.time_end} placeholder="Time End" disabled={item.payment_status == "Settled"}
                              onChange={(event) => {
                                var newAttendence = {
                                  ...Attendance,
                                  [Object.keys(Attendance)[index]]: {
                                    ...Object.values(Attendance)[index],
                                    "time_end": event.target.value
                                  }
                                }
                                setAttendance(newAttendence)
                                sortForDownload(newAttendence)
                              }}
                            />
                          </td>
                          <td>
                            <input className="input-common"
                              value={item.topic} placeholder="Topic" disabled={item.payment_status == "Settled"}
                              onChange={(event) => {
                                var newAttendence = {
                                  ...Attendance,
                                  [Object.keys(Attendance)[index]]: {
                                    ...Object.values(Attendance)[index],
                                    "topic": event.target.value
                                  }
                                }
                                setAttendance(newAttendence)
                                sortForDownload(newAttendence)
                              }}
                              onFocus={() => setOpenTopicPopup(index)}
                            />
                            {/* {openTopicPopup} */}
                            {openTopicPopup == index && (
                              <div
                                // className="topic-popup"
                                style={{ width: "200px", height: "200px", overflowY: "scroll", overflowX: "scroll" }}
                              >
                                <div className="topic-popup-title"
                                  onMouseDown={() => setOpenTopicPopup(null)}>
                                  Cancel
                                </div>

                                {TopicList1.filter(a =>
                                  a.subject.toLowerCase().includes(item.topic.toLowerCase()) ||
                                  a.Title.toLowerCase().includes(item.topic.toLowerCase()) ||
                                  a.Topic.toLowerCase().includes(item.topic.toLowerCase())
                                ).map((topic, index2) => (
                                  <button
                                    type="button"
                                    key={index2}
                                    className="topic-popup-item"
                                    onMouseDown={(e) => {
                                      // Prevent input blur before selection
                                      e.preventDefault();
                                      // handleChange(index, "topic", topic);
                                      setOpenTopicPopup(null);
                                      var newAttendence = {
                                        ...Attendance,
                                        [Object.keys(Attendance)[index]]: {
                                          ...Object.values(Attendance)[index],
                                          "topic": `${topic.Topic} : (${topic.Title}) - ${topic.subject}`
                                        }
                                      }
                                      setAttendance(newAttendence)
                                      sortForDownload(newAttendence)
                                      // function findIndex2D(arr, key, value) {
                                      const j = TopicList2.findIndex(obj => obj["ID"] === topic.ID);
                                      TopicList2[j] = {
                                        ...TopicList2[j],
                                        "Teacher": Name,
                                        "Date": item.date
                                      }
                                      // console.log(TopicList2)
                                      AdsPUTApi({
                                        meta: {
                                          topics_details: JSON.stringify(TopicList2)
                                        }
                                      }, slugs.db_slug_topics, "471")
                                    }}
                                  >
                                    <b>{topic.ID}</b><br />
                                    <b>{topic.Topic}</b><br />
                                    Title: {topic.Title}<br />
                                    Paper: {topic.subject}<br />
                                  </button>
                                ))}

                                <button
                                  type="button"
                                  className="topic-popup-close"
                                  onMouseDown={() => setOpenTopicPopup(null)}
                                >
                                  Close
                                </button>
                              </div>
                            )}
                          </td>
                          {/* <td>
                            <input className="input-common" style={{ width: "60px" }}
                              value={item.price} placeholder="Price" disabled={item.payment_status == "Settled"}
                              onChange={(event) => {
                                var newAttendence = {
                                  ...Attendance,
                                  [Object.keys(Attendance)[index]]: {
                                    ...Object.values(Attendance)[index],
                                    "price": event.target.value
                                  }
                                }
                                setAttendance(newAttendence)
                                sortForDownload(newAttendence)
                              }}
                            />
                          </td> */}

                          {/* <td>
                            {(Number(item.price) * 0.15).toFixed(2)}
                          </td>
                          <td>
                            {(Number(item.price) - Number(item.price) * 0.15).toFixed(2)}
                          </td> */}
                          {/* <td>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <div style={{ width: 10, height: 10, borderRadius: 10, backgroundColor: item.payment_status == "Unsettled" ? "red" : "green" }} /> &nbsp;
                              {item.payment_status}
                            </div>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {opencalendar &&
                    <div style={{ height: "250px" }} />
                  }
                </div>
              </div>
              <div className="row center m-2">
                <div className=" col-3" style={{ padding: "0 10px" }}>
                  <div className="sign-in-button-1"
                    onClick={() => {
                      var newValue = {
                        course_name: "",
                        batch_name: "",
                        session: "",
                        date: "",
                        time_start: "",
                        time_end: "",
                        type: "",
                        price: "",
                        topic: "",
                        payment_status: "Unsettled"
                      }
                      var lastkey = Object.keys(Attendance).length == 0 ? -1 : Number(Object.keys(Attendance)[Object.keys(Attendance).length - 1])
                      var newKey = `${lastkey + 1}`
                      var newObject = Attendance;
                      newObject = {
                        ...Attendance,
                        [newKey]: newValue
                      }
                      setAttendance(newObject)
                      setTimeout(() => {
                        const scrollContainer = AttendanceRef.current;
                        scrollContainer.scrollTo({
                          top: scrollContainer.scrollHeight + 70,
                          behavior: "smooth",
                        });
                        console.log(scrollContainer.scrollHeight)
                      }, 10)
                    }}
                  >
                    Add Attendance
                  </div>
                </div>
                <div className=" col-3" style={{ padding: "0 10px" }}>
                  {Object.values(Attendance).length !== 0 &&
                    <a target="_blank"
                      href=
                      {`https://wa.me/977${Phone1}?text=नमस्ते ${Name} जी, \n Class Details: ${Object.values(Attendance)[Object.values(Attendance).length - 1].topic} ZoomID: ${ZoomID}`}
                    >
                      <div className="sign-in-button-1"
                        onClick={() => { }}
                      >
                        Whatsapp
                      </div>
                    </a>
                  }
                </div>
                <div className=" col-3" style={{ padding: "0 10px" }}>
                  {/* <a target="_blank"
                    href=
                    {`mailto:${Email}?body=नमस्ते ${Name} जी, \n Class Details: ${JSON.stringify(Object.values(Attendance)[Object.values(Attendance).length - 1].topic)} ZoomID: ${ZoomID}`}
                  > */}
                  {Object.values(Attendance).length !== 0 &&
                    <div className="sign-in-button-1"
                      onClick={() => {
                        setEmailModal(true)

                      }}
                    >
                      Email
                    </div>
                  }
                  {/* </a> */}
                </div>
              </div>
            </div>
            <div>
            </div>
          </div>
        </div>
      }
      {EmailModal &&
        <section className="modal" >
          <div className="row" style={{ overflow: "hidden" }}>
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setEmailModal(false)
                  }}
                >X</div>
                <center>
                  Do you really want to Send Email?<br />
                  Email: {Email}<br />
                  Message: {`नमस्ते ${Name} जी, \n Class Details: ${JSON.stringify(Object.values(Attendance)[Object.values(Attendance).length - 1].topic)} ZoomID: ${ZoomID}`}<br />
                </center>
                <div className="row center">
                  <div className="col-3 center " >
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        // sendOTPEmail(Email,
                        //   `नमस्ते ${Name} जी, \n Class Details: ${JSON.stringify(Object.values(Attendance)[Object.values(Attendance).length - 1].topic)} ZoomID: ${ZoomID}`
                        // )
                        NodePOSTApi({
                          email: `${Email}`,
                          subject: "Class Email",
                          body: `नमस्ते ${Name} जी, <br/>Class Details: ${JSON.stringify(Object.values(Attendance)[Object.values(Attendance).length - 1].topic)}<br/> ZoomID: ${ZoomID}`
                        }, "send_email")
                        setEmailModal(false)

                      }}
                    >
                      Send Email
                    </div>
                  </div>
                  <div className="col-3 center " >
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        setEmailModal(false)
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      }
      {
        reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }

      {
        CourseSelectModal &&
        <section className="modal" >
          <div className="row" style={{ top: 50 }}>
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'scroll', padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setCourseSelectModal(false)
                  }}
                >X</div>
                <div>
                  <table>
                    <tr>
                      <td>SN</td>
                      <td>Course</td>
                      <td>Batch</td>
                      <td>Session</td>
                    </tr>
                    {Object.values(CourseDetails).map((item, index) => (
                      <tr key={index}
                        onClick={() => {

                          setAttendance({
                            ...Attendance,
                            [Object.keys(Attendance)[CourseSelectIndex]]: {
                              ...Object.values(Attendance)[CourseSelectIndex],
                              course_name: item.course_name,
                              batch_name: item.batch_name,
                              session: item.session,
                            }
                          })
                          setCourseSelectModal(false)
                        }}
                      >
                        <td>{index + 1}</td>
                        <td>{item.course_name}</td>
                        <td>{item.batch_name}</td>
                        <td>{item.session}</td>
                      </tr>
                    ))}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      }

      {
        CourseSelectModalAtt &&
        <section className="modal" >
          <div className="row" style={{ marginTop: 200 }}>
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'scroll', padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setCourseSelectModalAtt(false)
                  }}
                >X</div>
                <div>
                  <table>
                    <tr>
                      <td>SN</td>
                      <td>Course</td>
                      <td>Batch</td>
                      <td>Session</td>
                      <td>Price</td>
                    </tr>
                    {Object.values(CourseDetails).map((item, index) => (
                      <tr key={index}
                        onClick={() => {

                          var newAtt = {
                            ...Attendance,
                            [Object.keys(Attendance)[CourseSelectIndexAtt]]: {
                              ...Object.values(Attendance)[CourseSelectIndexAtt],
                              course_name: item.course_name,
                              batch_name: item.batch_name,
                              session: item.session,
                              price: item.course_joined_price,
                            }
                          }
                          setAttendance(newAtt)
                          sortForDownload(newAtt)
                          // PaymentCalculations(newAtt)

                          setCourseSelectModalAtt(false)
                        }}
                      >
                        <td>{index + 1}</td>
                        <td>{item.course_name}</td>
                        <td>{item.batch_name}</td>
                        <td>{item.session}</td>
                        <td>{item.course_joined_price}</td>
                      </tr>
                    ))}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      }
    </div >
  )

}